import SimpleBar from "simplebar";

export default context => {
    $('.custom-scroll:not(ul)', context).each(function () {
        new SimpleBar($(this)[0])
    })
}
